import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window?.localStorage,
    storageKey: 'supabase-auth-token',
    flowType: 'pkce',
    retryAttempts: 3,
    debug: false
  },
  global: {
    headers: {
      'x-application-name': 'vivaconsul-healthcare'
    },
    //fetch: (...args) => {
    //  console.log('SUPABASE REQUEST:', args[0], args[1]);  // Faz mostrar a query sendo executada no log.
    //  return fetch(...args);
    //}    
  }
});